/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../styles/variables';
import AccessibleSVG, { SVGProps } from '../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const CustomerSupport140 = (props: SVGProps) => (
    <AccessibleSVG width={140} height={140} viewBox="0 0 140 140" {...props}>
        <path
            d="M117 24a8 8 0 100-16 8 8 0 000 16zM22 43c8.837 0 16-7.163 16-16s-7.163-16-16-16S6 18.163 6 27s7.163 16 16 16zm100 77c0 6.627-5.373 12-12 12s-12-5.373-12-12 5.373-12 12-12 12 5.373 12 12zm-86.863-17.11c6.28 6.688 14.775 11.35 24.324 12.976A3.998 3.998 0 0063 118h7.999a4 4 0 000-8h-8a3.998 3.998 0 00-3.365 1.836c-11.373-2.078-20.993-8.889-26.542-18.298A34.506 34.506 0 0133 91V63c0-18.778 15.222-34 34-34 11.853 0 22.29 6.066 28.376 15.263C86.313 48.325 80 57.425 80 68v26h20.869C99.351 111.373 84.767 125 67 125c-14.595 0-27.042-9.196-31.863-22.11z"
            opacity={0.1}
            fill={vars.bdlGray50}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M33.08 44.945c-.836 1.524-2.493 2.426-4.169 2.22A38.545 38.545 0 0027 59.187v15.628c0 18.989 13.863 34.482 32.193 37.957A4.001 4.001 0 0163 110h8a4 4 0 010 8h-8a4.001 4.001 0 01-3.923-3.217C43.133 111.857 30.314 100.256 26.307 85H25c-6.075 0-11-4.925-11-11v-8c0-6.075 4.925-11 11-11h.213a40.402 40.402 0 011.836-8.578c-1.419-1.056-1.985-2.995-1.085-4.655C34.331 26.336 49.655 16 67.174 16c17.212 0 32.306 9.979 40.765 24.966.208.369.343.753.411 1.139a26.312 26.312 0 00-2.125-.104 1.14 1.14 0 00-.028-.052C98.046 27.506 83.573 18 67.173 18c-16.69 0-31.385 9.846-39.45 24.72-.467.86-.04 2.053 1.122 2.396.888.262 1.947-.158 2.482-1.133C38.6 30.73 51.903 22.038 67.173 22.038c14.613 0 27.427 7.953 34.876 20.26-.709.108-1.409.245-2.098.41-7.17-11.406-19.176-18.67-32.778-18.67-14.47 0-27.136 8.232-34.092 20.907zM25.059 57A41.265 41.265 0 0025 59.186v15.628c0 2.811.288 5.548.836 8.186H25a9 9 0 01-9-9v-8a9 9 0 019-9h.058zM63 116a1.999 1.999 0 01-1.788-2.898A2 2 0 0163 112h8a2 2 0 110 4h-8z"
            fill={vars.bdlGray50}
        />
        <path
            d="M67 31c11.067 0 20.823 5.618 26.569 14.159a26.13 26.13 0 011.806-.896C89.29 35.066 78.853 29 67 29c-18.778 0-34 15.222-34 34v28c0 .854.032 1.7.093 2.538a37.337 37.337 0 002.522 3.74A32.152 32.152 0 0135 91V63c0-17.673 14.327-32 32-32zm-31.863 71.89C39.958 115.804 52.405 125 67 125c17.767 0 32.35-13.627 33.869-31h-2.008c-1.512 16.266-15.2 29-31.861 29-12.037 0-22.522-6.646-27.985-16.469a42.277 42.277 0 01-3.878-3.641zM96 60a1 1 0 011-1h18a1 1 0 010 2H97a1 1 0 01-1-1zm1 7a1 1 0 100 2h18a1 1 0 000-2H97zm0 8a1 1 0 100 2h14a1 1 0 000-2H97z"
            fill={vars.bdlGray50}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M106 44c-13.255 0-24 10.745-24 24v24h24c13.255 0 24-10.745 24-24s-10.745-24-24-24zM84 90h22c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22v22z"
            fill={vars.bdlGray50}
        />
        <path
            d="M57 96.889A7.111 7.111 0 0064.111 104h5.778A7.111 7.111 0 0077 96.889a.889.889 0 00-.889-.889H57.89a.889.889 0 00-.889.889z"
            fill={vars.bdlGray50}
        />
    </AccessibleSVG>
);

export default CustomerSupport140;
